import React from 'react';
import PropTypes from 'prop-types';

import FilterNumberPair from 'components/search_sidebar/filter_number_pair';
import FilterDatePickerPair from 'components/search_sidebar/filter_datepicker_pair';

import { filterLabelMappings, filterKeyMappings } from 'bundles/research/index/research_constants';

export default class SaleFilterGroup extends React.Component {
  static propTypes = {
    compsView: PropTypes.bool,
    saleFilter: PropTypes.object.isRequired,
    onFilterChange: PropTypes.func.isRequired
  };

  render() {
    const {
      saleFilter,
      onFilterChange
    } = this.props;

    return (
      <div className="sale-container">
        <div className="top-buffer-sm row right-buffer-sm left-buffer-sm">
          <FilterNumberPair
            filter={saleFilter}
            label={filterLabelMappings['salesPrice']}
            valueKeys={filterKeyMappings['salesPrice']}
            onChange={onFilterChange}
          />
        </div>
        <div className="row right-buffer-sm left-buffer-sm">
          <FilterDatePickerPair
            filter={saleFilter}
            label={filterLabelMappings['salesDate']}
            valueKeys={filterKeyMappings['salesDate']}
            onChange={onFilterChange}
          />
        </div>
        <div className="row right-buffer-sm left-buffer-sm">
          <FilterNumberPair
            filter={saleFilter}
            label={filterLabelMappings['sfPrice']}
            valueKeys={filterKeyMappings['sfPrice']}
            onChange={onFilterChange}
          />
        </div>
        <div className="row right-buffer-sm left-buffer-sm">
          <FilterNumberPair
            filter={saleFilter}
            label={filterLabelMappings['unitPrice']}
            valueKeys={filterKeyMappings['unitPrice']}
            onChange={onFilterChange}
          />
        </div>
        <div className="row right-buffer-sm left-buffer-sm">
          <FilterNumberPair
            filter={saleFilter}
            label={filterLabelMappings['capRate']}
            valueKeys={filterKeyMappings['capRate']}
            onChange={onFilterChange}
          />
        </div>
      </div>
    );
  }
}